<div class="sheet-page">
  <div class="container-xxl sheet">
    <header class="sheet-head">
      <p class="sheet-kicker">Archivio artistico</p>
      <div class="sheet-title-row">
        <button class="sheet-back" type="button" aria-label="Indietro" (click)="goBack()">
          <i class="bi bi-arrow-left" aria-hidden="true"></i>
          <span class="back-label">Indietro</span>
        </button>
        <span class="sheet-divider" aria-hidden="true"></span>
        <h1>{{ article?.generalForm?.title }}</h1>
        @if (article?.generalForm?.code) {
          <p class="sheet-code"><span>Codice:</span> {{ article?.generalForm?.code }}</p>
        }
      </div>
    </header>

    <div class="sheet-layout">
      <div class="sheet-media">
        <section class="sheet-gallery" aria-label="File della scheda">
          @if (files.length > 0) {
            @let file = files[currentImg];
            <div class="gallery-stage">
              @if (file.ext != 'pdf' && file.ext != 'mp4' && file.ext != 'youtube') {
                <button class="gallery-frame" type="button" (click)="openFullscreenModal(file)"
                  [attr.aria-label]="'Apri ' + (file.title || article?.generalForm?.title || 'immagine') + ' a schermo intero'">
                  <img [src]="urlServerLaraApiMultimedia + file.src" [alt]="file.title || article?.generalForm?.title || ''"
                    (contextmenu)="$event.preventDefault()">
                </button>
              }
              @if (file.ext == 'pdf') {
                <button class="gallery-frame" type="button" (click)="openFullscreenModal(file)"
                  [attr.aria-label]="'Apri ' + (file.title || 'PDF') + ' a schermo intero'">
                  <img class="is-document" [src]="thumbnails[file.src] || 'assets/img/pdfCover.png'"
                    [alt]="file.title || 'Documento PDF'">
                </button>
              }
              @if (file.ext == 'mp4') {
                <video class="gallery-video" controls>
                  <source [src]="urlServerLaraApiMultimedia + file.src" type="video/mp4">
                </video>
              }
              @if (file.ext == 'youtube') {
                <iframe class="gallery-video" [src]="file.sanitized_url" [title]="file.title || article?.generalForm?.title || 'Video'"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen>
                </iframe>
              }

              @if (files.length > 1) {
                <button class="gallery-nav gallery-nav-prev" type="button" (click)="prevImg()" aria-label="File precedente">
                  <i class="bi bi-chevron-left" aria-hidden="true"></i>
                </button>
                <button class="gallery-nav gallery-nav-next" type="button" (click)="nextImg()" aria-label="File successivo">
                  <i class="bi bi-chevron-right" aria-hidden="true"></i>
                </button>
              }
            </div>

            @if (files.length > 1) {
              <div class="gallery-thumbs" role="tablist" aria-label="Anteprime">
                @for (img of files; track img.id; let i = $index) {
                  <button #thumb class="gallery-thumb" type="button" role="tab" [class.is-active]="i === currentImg"
                    [attr.aria-selected]="i === currentImg" [attr.aria-label]="img.title || 'File ' + (i + 1)"
                    (click)="goToImg(i)">
                    @if (img.ext != 'pdf' && img.ext != 'mp4' && img.ext != 'youtube') {
                      <img [src]="urlServerLaraApiMultimedia + img.src" [alt]="img.title || ''"
                        (contextmenu)="$event.preventDefault()">
                    }
                    @if (img.ext == 'pdf') {
                      <img class="is-document" [src]="thumbnails[img.src] || 'assets/img/pdfCover.png'"
                        [alt]="img.title || 'PDF'">
                    }
                    @if (img.ext == 'mp4' || img.ext == 'youtube') {
                      <img [src]="urlServerLaraApiMultimedia + img.src_placeholder" [alt]="img.title || 'Video'">
                    }
                  </button>
                }
              </div>
            }
          } @else if (filesLoaded) {
            <p class="gallery-empty">Nessun file associato a questa scheda.</p>
          } @else {
            <div class="gallery-stage gallery-pending" aria-hidden="true"></div>
          }
        </section>

        @if (authService.isLoggedIn() && article) {
          <div class="sheet-actions">
            <a class="sheet-edit" [routerLink]="['/modificaSchedaArtistica', article.generalForm.id]">
              <i class="bi bi-pencil" aria-hidden="true"></i>
              Modifica scheda
            </a>
            <button class="sheet-delete" type="button" (click)="deleteArticle(article.generalForm.id)">
              <i class="bi bi-trash" aria-hidden="true"></i>
              Elimina
            </button>
          </div>
        }

        <section class="sheet-panel">
          <h2><i class="bi bi-box-seam-fill" aria-hidden="true"></i>Informazioni oggetto e soggetto</h2>
          <app-object-readonly [objectInfo]="article?.objectForm"></app-object-readonly>
        </section>

        @if (article?.relationsForm && article?.relationsForm?.relations.length > 0) {
          <section class="sheet-panel">
            <h2><i class="bi bi-diagram-3-fill" aria-hidden="true"></i>Relazioni</h2>
            <app-relations-readonly [relationsInfo]="article?.relationsForm"></app-relations-readonly>
          </section>
        }

        @if (article?.analyticalDataForm) {
          <section class="sheet-panel">
            <h2><i class="bi bi-graph-up-arrow" aria-hidden="true"></i>Dati analitici</h2>
            <app-analytical-data-readonly [analyticalData]="article?.analyticalDataForm"></app-analytical-data-readonly>
          </section>
        }

        @if (article?.sourcesForm) {
          <section class="sheet-panel">
            <h2><i class="bi bi-book-fill" aria-hidden="true"></i>Fonti e documenti di riferimento</h2>
            <app-sources-readonly [sources]="article?.sourcesForm"></app-sources-readonly>
          </section>
        }
      </div>

      <aside class="sheet-side">
        <section class="sheet-panel">
          <h2><i class="bi bi-info-circle-fill" aria-hidden="true"></i>Dati scheda</h2>
          <app-general-info-readonly [generalInfo]="article?.generalForm"></app-general-info-readonly>
        </section>

        @if (article?.locationForm && (article?.locationForm.original_location || article?.locationForm.museumInventory.length > 0)) {
          <section class="sheet-panel">
            <h2><i class="bi bi-geo-alt-fill" aria-hidden="true"></i>Ubicazione e dati patrimoniali</h2>
            <app-location-data-readonly [locationData]="article?.locationForm"></app-location-data-readonly>
          </section>
        }

        @if (article?.chronologyForm && article?.chronologyForm.length > 0) {
          <section class="sheet-panel">
            <h2><i class="bi bi-clock-history" aria-hidden="true"></i>Cronologia</h2>
            <app-chronology-readonly [chronologyData]="article?.chronologyForm"></app-chronology-readonly>
          </section>
        }

        @if (article?.culturalForm && (article?.culturalForm.author.length > 0 || article?.culturalForm.scope.length > 0
          || article?.culturalForm.othersAttributions.length > 0 || article?.culturalForm.client.length > 0)) {
          <section class="sheet-panel">
            <h2><i class="bi bi-mortarboard-fill" aria-hidden="true"></i>Definizione culturale</h2>
            <app-cultural-definition-readonly [culturalDefinition]="article?.culturalForm"></app-cultural-definition-readonly>
          </section>
        }

        @if (article?.technicalDataForm && (article?.technicalDataForm.technique || article?.technicalDataForm.measures.length > 0)) {
          <section class="sheet-panel">
            <h2><i class="bi bi-tools" aria-hidden="true"></i>Dati tecnici</h2>
            <app-technical-data-readonly [technicalData]="article?.technicalDataForm"></app-technical-data-readonly>
          </section>
        }

        @if (article?.conservationForm && (article?.conservationForm.conservationStatus || article?.conservationForm.specificIndications)) {
          <section class="sheet-panel">
            <h2><i class="bi bi-shield-check" aria-hidden="true"></i>Conservazione</h2>
            <app-conservation-readonly [conservationData]="article?.conservationForm"></app-conservation-readonly>
          </section>
        }

        @if (article?.legalConditionForm) {
          <section class="sheet-panel">
            <h2><i class="bi bi-shield-lock-fill" aria-hidden="true"></i>Condizione giuridica e vincoli</h2>
            <app-legal-condition-readonly [legalCondition]="article?.legalConditionForm"></app-legal-condition-readonly>
          </section>
        }
      </aside>
    </div>
  </div>
</div>
